export { default } from './toPairsIn.js'



//////////////////
// WEBPACK FOOTER
// ./~/lodash-es/entriesIn.js
// module id = 604
// module chunks = 41